import React from 'react';
import { Loader } from '@saviynt/design-system';

import './LoadingState.css';

/** Loading spinner centered both vertically and horizontally */
function LoadingState(): JSX.Element {
  return (
    <div className='Auth_LoadingState'>
      <Loader
        className='Auth_LoadingState-spinner'
        kind='loop'
        format='main'
        color='brand'
      />
    </div>
  );
}

export default LoadingState;
